import L from "leaflet";
import "leaflet/dist/leaflet.css";
import './ipha/ipha_map.css'
import {type} from "jquery";

const countriesData = require("./ipha/ipha-countries.json")


let map = L.map('map', {zoomDelta: 0.5, wheelPxPerZoomLevel: 50, zoomSnap: 0, worldCopyJump: true}).setView([45, 15], 2);
//map.setMaxBounds(map.getBounds());

let tiles = L.tileLayer('https://osm.passivehouse.com/{z}/{x}/{y}.png', {
// let tiles = L.tileLayer('https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg', {
    maxZoom: 19, minZoom:2,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
    // attribution: `Map tiles by <a href="http://stamen.com">Stamen Design</a>, under
    // <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by
    // <a href="http://openstreetmap.org">OpenStreetMap</a>, under
    // <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>.`
}).addTo(map);

let info = L.control();
let affiliatesData = []
var load_affiliate_data = function () {
    var data = JSON.parse(document.getElementById('ipha_map_data').textContent);
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            affiliatesData = JSON.parse(xhr.responseText);
            map.eachLayer(country => {
                geojson.resetStyle(country.target);
            })
            resetHighlight()
            info.update();
        }
    };
    xhr.open('GET', data.data_url, true);
    xhr.send();
}
info.onAdd = function (map) {
    this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
    load_affiliate_data();
    return this._div;
};
function get_affiliates(country, country_eh) {
    let affiliates = [];
    for (const affiliate of affiliatesData){
        if(
            affiliate.countries.includes(country) ||
            affiliate.countries.includes(country_eh)
        ){
            affiliates.push(affiliate)
        }
    }
    return affiliates
}

// method that we will use to update the control based on feature properties passed
info.update = function (props) {
    if (typeof props !== "undefined"){
        let affiliates = get_affiliates(props.ISO_A2, props.ISO_A2_EH)
        let names = ''
        for (const affiliate of affiliates){
            if(affiliate.name.length > 50){
                names += '<h3><img src="' + affiliate.logo + '" style="max-width: 120px; max-height: 120px"/>' + affiliate.name + '</h3>'
            } else if(affiliate.name.length > 40){
                names += '<h2><img src="' + affiliate.logo + '" style="max-width: 120px; max-height: 120px"/>' + affiliate.name + '</h2>'
            } else {
                names += '<h1><img src="' + affiliate.logo + '" style="max-width: 120px; max-height: 120px"/>' + affiliate.name + '</h1>'
            }
        }
        this._div.innerHTML = '' + (props ?
            names + props.NAME_EN
            : 'Hover over a country');
    }
};

info.addTo(map);

function getColor(affiliates) {
    // let status = 'pre'
    // for (const affiliate of affiliates){
    //     if (affiliate.status !== 'pre'){
    //         status = affiliate.status
    //     }
    // }
    //return status === 'pre' ? '#a1b660' :
    //    '#97bf0d';
    if (affiliates.length === 0){
        return '#97bf0d00'
    }
    return '#97bf0d';
}

function style(feature) {
    let affiliates = get_affiliates(feature.properties.ISO_A2, feature.properties.ISO_A2_EH)
    return {
        fillColor: getColor(affiliates),
        weight: 2,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.7
    };
}

function highlightFeature(e) {
    let layer = e.target;

    layer.setStyle({
        weight: 5,
        color: '#666',
        dashArray: '',
        fillOpacity: 0.7
    });

    layer.bringToFront();

    info.update(layer.feature.properties);

}

function resetHighlight(e) {
    geojson.resetStyle(e.target);
}

function featureClick(e) {
    load_affiliate_data();
    try {
        let affiliates = get_affiliates(e.target.feature.properties.ISO_A2, e.target.feature.properties.ISO_A2_EH)
        let content = '<div class="ui divided items">'
        for (const affiliate of affiliates){
            let name = affiliate.name
            let url_register = affiliate.register_url
            let description = affiliate.description
            let icon = affiliate.logo
            content += '<div class="item">' +
                '<div class="image">' +
                '<img class="logo" src="'+icon+'"/>' +
                '</div>' +
                '<div class="content">' +
                '<div class="header">'+name+'</div>'
            if (description && affiliates.length > 1) {
                content += `<div class="description"><details class="ui accordion">
                    <summary class="title">${document.getElementById("text_learn_more").textContent}</summary>
                    <div class="content">${description}</div></details></div>`
            } else if (description) {
                content += '<div class="description">' + description + '</div>'
            }
            content += '<div className="extra"><div className="ui buttons">'
            if (affiliate.url){
                content += '<a href="'+affiliate.url+'" class="ui right floated circular icon button" target="_blank">'
                    + '<i class="globe icon"></i></a>'
            }
            if (affiliate.social_media){
                for (const social_media of affiliate.social_media) {
                    if (social_media.icon === 'bsky') {
                        content += '<a href="' + social_media.url + '" class="ui right floated circular twitter icon button" target="_blank" style="line-height: 0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512", style="width: 1em"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#FFFFFF" d="M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"/></svg></a>'
                    } else if (social_media.icon === 'twitter'){
                        content += '<a href="' + social_media.url + '" class="ui right floated circular twitter icon button" target="_blank" style="line-height: 0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512", style="width: 1em"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#FFFFFF" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a>'
                    } else {
                        content += '<a href="' + social_media.url + '" class="ui right floated circular ' + social_media.icon
                            + ' icon button" target="_blank"><i class="' + social_media.icon + ' icon"></i></a>'
                    }
                }
            }
            content += '</div></div></div></div>'
            // actions.push({
            //     text: 'Go to website of '+ name,
            //     class: 'green',
            //     icon: icon,
            //     click: function () {
            //         window.open(url, '_blank')
            //     }
            //
            // })
        }
        content += '</div>'

        $.modal({
            title: e.target.feature.properties.NAME_EN,
            closeIcon: true,
            content: content
        }).modal('show').$.modal('confirm', 'Attention!', 'Ready?', function (choice) {
            $.toast({message: 'You ' + (choice ? 'Accepted' : 'Declined')});
        });
    } catch (err) {
    }

}

function onEachFeature(feature, layer) {
    layer.on({
        mouseover: highlightFeature,
        mouseout: resetHighlight,
        click: featureClick
    });
}

let geojson = L.geoJson(countriesData, {
    style: style,
    onEachFeature: onEachFeature
}).addTo(map);